import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { CenteredFlexRow, FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const TotalVisitsWrapper = styled.div`
    text-align: center;
`;

export const Title = styled.div`
    ${setFontVariant("body1", carbon[500])};
`;

export const SidesWrapper = styled(CenteredFlexRow)`
    gap: 20px;
    margin-top: 20px;
`;

export const LeftBarContainer = styled(FlexColumn)`
    align-items: end;
    justify-content: flex-end;
`;

export const RightBarContainer = styled(FlexColumn)`
    align-items: start;
    justify-content: flex-start;
`;

export const BarContainer = styled(FlexRow)`
    align-items: end;
    justify-content: center;
    height: 96px;
    margin-bottom: 10px;
`;

export const DisplayValue = styled.div`
    ${setFontVariant("h3", carbon[500])};
`;

export const Period = styled.div`
    ${setFontVariant("chip1", carbon[300])};
`;

export const NoDataContainer = styled(CenteredFlexRow)`
    width: 100%;
    align-content: center;
    height: auto;
`;
